/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Month_AugInputs */

const en_better_studio_month_aug = /** @type {(inputs: Better_Studio_Month_AugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aug`)
};

/**
* | output |
* | --- |
* | "Aug" |
*
* @param {Better_Studio_Month_AugInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_month_aug = /** @type {((inputs?: Better_Studio_Month_AugInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Month_AugInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_month_aug(inputs)
});